import AuthenticatedRoute from './AuthenticatedRouteContainer';

export default AuthenticatedRoute;
